import React from 'react';

import Link from '@/components/commons/link';
import Container, { ContainerTypes } from '@/components/commons/page-elements/Container';
import Heading, { HeadingSizes } from '@/components/commons/page-elements/Heading';

interface Props {
    readonly heading: {
        readonly size?: HeadingSizes;
        readonly externalStyles?: string;
        readonly bold?: boolean;
        readonly children: Element;
    };
    readonly body: {
        readonly text: string;
        readonly style: string;
    };
    readonly image?: {
        readonly src?: string;
        readonly alt?: string;
        readonly style?: string;
    };
    readonly link?: {
        readonly url?: string;
        readonly children?: React.JSX.Element;
        readonly style?: string;
    };
    readonly target?: string;
    readonly externalStyles?: string;
    readonly externalContainerStyles?: string,
    readonly externalTextBoxStyles?: string,
}

/**
 * Component used to add consistent styling for Headings throughout
 * the app, also supports externalStyles if tweaks are needed.
 */
function BigNavigationCard({
    heading,
    body,
    link = null,
    image = null,
    target = '',
    externalStyles = null,
    externalTextBoxStyles = null,
    externalContainerStyles = null,
}: Props) {
    return (
        <Container type={ContainerTypes.WHITE} externalStyles={externalContainerStyles}>
            <div className={`flex flex-col md:flex-row justify-between items-center ${externalStyles}`}>
                {image && <img src={image.src} alt={image.alt} className={image.style} />}
                <div className={`${image ? 'md:ml-10' : ''} xl:mt-0 ${externalTextBoxStyles}`}>
                    <Heading
                        size={heading.size}
                        bold={heading.bold}
                        externalStyles={heading.externalStyles}
                    >
                        {heading.children}
                    </Heading>
                    <p className={body.style}>{body.text}</p>
                    {link && (
                        <Link to={link.url} target={target} className={link.style}>
                            {link.children}
                        </Link>
                    )}
                </div>
            </div>
        </Container>
    );
}

export default BigNavigationCard;
